import React from 'react';
import { Icon } from '@iconify/react';

function CompanySection({ company, canEdit, onOpenModal }) {
  return (
    <div id="company" className="mb-4 pb-3">
      <div className="d-flex align-items-center justify-content-between mb-2 mt-3">
        <h4 className="d-flex align-items-center mb-0">
          <Icon className="iconify fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:buildings-bold-duotone" />
          Company Profile (会社詳細情報)
        </h4>
        <div>
          {canEdit ? (
            <a href="#modalEdit" data-bs-toggle="modal" onClick={() => onOpenModal('company')} className="btn btn-theme btn-sm">
              <i className="fa fa-edit me-1"></i>会社情報を編集
            </a>
          ) : (
            <button className="btn btn-secondary btn-sm disabled" title="権限がありません">編集権限なし</button>
          )}
        </div>
      </div>
      <p>自社およびグループ会社の登録情報を一括管理します。</p>

      <div className="card">
        <div className="card-body fw-bold py-2">
          <div className="row py-2 border-b">
            <div className="col-md-3 text-muted">会社名</div>
            <div className="col-md-9 text-body">{company.name_of_company || '未設定'}</div>
          </div>
          <div className="row py-2 border-b">
            <div className="col-md-3 text-muted">代表者名</div>
            <div className="col-md-9 text-body">{company.name_of_representative || '未設定'}</div>
          </div>
          <div className="row py-2 border-b">
            <div className="col-md-3 text-muted">代表メール</div>
            <div className="col-md-9 text-body">{company.email || '未設定'}</div>
          </div>
          <div className="row py-2 border-b">
            <div className="col-md-3 text-muted">郵便番号</div>
            <div className="col-md-9 text-body">〒 {company.zipcode || '未設定'}</div>
          </div>
          <div className="row py-2 border-b">
            <div className="col-md-3 text-muted">所在地（住所）</div>
            <div className="col-md-9 text-body">
              {company.address1 || company.address2 || company.address3 ? (
                `${company.address1 || ''} ${company.address2 || ''} ${company.address3 || ''} ${company.address4 || ''}`
              ) : '未設定'}
            </div>
          </div>
          <div className="row py-2 border-b">
            <div className="col-md-3 text-muted">電話番号 (メイン / サブ)</div>
            <div className="col-md-9 text-body">
              {company.phone || '未設定'} {company.phone2 ? ` / ${company.phone2}` : ''}
            </div>
          </div>
          <div className="row py-2 border-b">
            <div className="col-md-3 text-muted">FAX番号</div>
            <div className="col-md-9 text-body">{company.fax || '未設定'}</div>
          </div>
          <div className="row py-2">
            <div className="col-md-3 text-muted">備考・メモ</div>
            <div className="col-md-9 text-body text-opacity-70 fw-normal">{company.memo || 'なし'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanySection;